var map = {
	"./assert.d.ts": 96503,
	"./assert/strict.d.ts": 60451,
	"./async_hooks.d.ts": 43770,
	"./buffer.d.ts": 80219,
	"./child_process.d.ts": 12069,
	"./cluster.d.ts": 18635,
	"./console.d.ts": 26004,
	"./constants.d.ts": 59228,
	"./crypto.d.ts": 44216,
	"./dgram.d.ts": 49005,
	"./diagnostics_channel.d.ts": 19505,
	"./dns.d.ts": 72298,
	"./dns/promises.d.ts": 37395,
	"./dom-events.d.ts": 57335,
	"./domain.d.ts": 40305,
	"./events.d.ts": 41512,
	"./fs.d.ts": 49730,
	"./fs/promises.d.ts": 71547,
	"./globals.d.ts": 15725,
	"./globals.global.d.ts": 93428,
	"./http.d.ts": 82485,
	"./http2.d.ts": 40399,
	"./https.d.ts": 91916,
	"./index.d.ts": 42385,
	"./inspector.d.ts": 24684,
	"./module.d.ts": 28585,
	"./net.d.ts": 64386,
	"./os.d.ts": 74787,
	"./path.d.ts": 2902,
	"./perf_hooks.d.ts": 46273,
	"./process.d.ts": 22592,
	"./punycode.d.ts": 25334,
	"./querystring.d.ts": 28712,
	"./readline.d.ts": 83999,
	"./readline/promises.d.ts": 54716,
	"./repl.d.ts": 57212,
	"./stream.d.ts": 17341,
	"./stream/consumers.d.ts": 2547,
	"./stream/promises.d.ts": 26138,
	"./stream/web.d.ts": 74312,
	"./string_decoder.d.ts": 49891,
	"./test.d.ts": 54725,
	"./timers.d.ts": 41063,
	"./timers/promises.d.ts": 25076,
	"./tls.d.ts": 58700,
	"./trace_events.d.ts": 75662,
	"./ts4.8/assert.d.ts": 22681,
	"./ts4.8/assert/strict.d.ts": 87641,
	"./ts4.8/async_hooks.d.ts": 31732,
	"./ts4.8/buffer.d.ts": 28593,
	"./ts4.8/child_process.d.ts": 31515,
	"./ts4.8/cluster.d.ts": 39641,
	"./ts4.8/console.d.ts": 45810,
	"./ts4.8/constants.d.ts": 43182,
	"./ts4.8/crypto.d.ts": 58842,
	"./ts4.8/dgram.d.ts": 25908,
	"./ts4.8/diagnostics_channel.d.ts": 86931,
	"./ts4.8/dns.d.ts": 94244,
	"./ts4.8/dns/promises.d.ts": 72581,
	"./ts4.8/dom-events.d.ts": 15821,
	"./ts4.8/domain.d.ts": 91767,
	"./ts4.8/events.d.ts": 18554,
	"./ts4.8/fs.d.ts": 77384,
	"./ts4.8/fs/promises.d.ts": 63953,
	"./ts4.8/globals.d.ts": 26663,
	"./ts4.8/globals.global.d.ts": 89290,
	"./ts4.8/http.d.ts": 88203,
	"./ts4.8/http2.d.ts": 89437,
	"./ts4.8/https.d.ts": 87218,
	"./ts4.8/index.d.ts": 59015,
	"./ts4.8/inspector.d.ts": 3954,
	"./ts4.8/module.d.ts": 44435,
	"./ts4.8/net.d.ts": 6400,
	"./ts4.8/os.d.ts": 69009,
	"./ts4.8/path.d.ts": 20428,
	"./ts4.8/perf_hooks.d.ts": 6331,
	"./ts4.8/process.d.ts": 70342,
	"./ts4.8/punycode.d.ts": 99960,
	"./ts4.8/querystring.d.ts": 84622,
	"./ts4.8/readline.d.ts": 79901,
	"./ts4.8/readline/promises.d.ts": 49658,
	"./ts4.8/repl.d.ts": 68302,
	"./ts4.8/stream.d.ts": 93675,
	"./ts4.8/stream/consumers.d.ts": 97437,
	"./ts4.8/stream/promises.d.ts": 86176,
	"./ts4.8/stream/web.d.ts": 98178,
	"./ts4.8/string_decoder.d.ts": 42457,
	"./ts4.8/test.d.ts": 68719,
	"./ts4.8/timers.d.ts": 57837,
	"./ts4.8/timers/promises.d.ts": 3178,
	"./ts4.8/tls.d.ts": 70178,
	"./ts4.8/trace_events.d.ts": 77580,
	"./ts4.8/tty.d.ts": 43272,
	"./ts4.8/url.d.ts": 410,
	"./ts4.8/util.d.ts": 48199,
	"./ts4.8/v8.d.ts": 86949,
	"./ts4.8/vm.d.ts": 14262,
	"./ts4.8/wasi.d.ts": 28951,
	"./ts4.8/worker_threads.d.ts": 90131,
	"./ts4.8/zlib.d.ts": 72102,
	"./tty.d.ts": 76326,
	"./url.d.ts": 46524,
	"./util.d.ts": 98009,
	"./v8.d.ts": 71667,
	"./vm.d.ts": 53276,
	"./wasi.d.ts": 30793,
	"./worker_threads.d.ts": 38285,
	"./zlib.d.ts": 35672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32257;